var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: "客服机器人",
      description: "客服机器人可通过与线上用户的问答记录，对线上问句自动分类，聚类发现新知识，并根据业务流程，引导用户理清复杂问题，辅助运营人员智能高效解决客户问题。"
    }
  })], 1), _c("div", {
    staticClass: "effective"
  }, [_c("div", {
    staticClass: "effective_main"
  }, [_c("div", {
    staticClass: "eTitle"
  }, [_vm._v("AI客服机器人是企业最高效的员工")]), _c("FlowGrid", {
    staticClass: "eItems"
  }, _vm._l(_vm.effectives, function ({
    title,
    desc,
    icon
  }) {
    return _c("div", {
      key: title,
      staticClass: "eItem"
    }, [_c("img", {
      staticClass: "eImg",
      attrs: {
        src: icon,
        alt: ""
      }
    }), _c("h3", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
  }), 0)], 1)]), _c("div", {
    staticClass: "skill"
  }, [_c("SmartTitle", {
    attrs: {
      title: "强大功能，自如应对各种需求",
      desc: "WHAT CAB AN INTELLIGENT OUTBOUND ROBOT OF TONGHUASHUN DO?"
    }
  }), _c("div", {
    staticClass: "skill_main"
  }, [_c("SmartCard", {
    attrs: {
      skills: _vm.skills
    }
  })], 1)], 1), _c("Cases", {
    attrs: {
      source: "aiProduct"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };